<script>
import VInput from '@/components/common/VInput.vue'
import VFormField from '@/components/form/VFormField.vue'
import VFormRow from '@/components/form/VFormRow.vue'

export default {
  name: 'VRepeatInput',
  components: {
    VInput,
    VFormField,
    VFormRow
  },
  props: {
    errors: { type: Object, default: () => {}, required: false },
    label: { type: String, required: true },
    typeElements: { type: String, required: true },
    elements: { type: Array, required: true },
    removeElementFromArray: { type: Function, required: true },
    changeElementOnArray: { type: Function, required: true },
    addElementOnArray: { type: Function, required: true }
  }
}
</script>

<template>
  <v-form-row>
    <v-form-field :label="label" :error-message="errors">
      <template #default="{ validationErrors }">
        <div class="v-input--group">
          <template v-for="(userProperty, id) in elements">
            <v-input
              :key="id"
              :v-model="elements[id]"
              :value="userProperty"
              :is-error="!!validationErrors.length"
              :is-deleted="true"
              @clear="() => removeElementFromArray(id, typeElements)"
              @input="val => changeElementOnArray(val, typeElements, id)"
            />
          </template>
        </div>
      </template>
    </v-form-field>
    <div class="form-dynamic-select__controls" style="padding-top: 5px">
      <button type="button" class="button button--text" @click="() => addElementOnArray('', typeElements)">
        + добавить ещё
      </button>
    </div>
  </v-form-row>
</template>

<style scoped lang="scss" />
